import { View, StyleSheet, Image } from "@react-pdf/renderer";
import React from "react";
import PdfLogo from "../../assets/images/Trust-telecom-New-Logo.png";

const styles = StyleSheet.create({
  headerContainer: {
    position: "relative",
    backgroundColor: "#726c60",
    height: 40,
  },

  headerBarSecondary: {
    position: "absolute",
    height: "100%",
    width: "190px",
    backgroundColor: "#f1f1f1",
  },
  logoContainer: {
    alignItems: "flex-end",
  },
  pdfLogo: {
    width: "155px",
    marginTop:5,
    // marginBottom:5,
  },
  children:{
    paddingHorizontal:25
  }
});

const Header = ({ children }) => {
  return (
    <View>
      <View style={styles.headerContainer} fixed></View>
      <View style={styles.logoContainer} fixed>
        <Image src={PdfLogo} style={styles.pdfLogo} />
      </View>
      <View style={styles.children}>{children}</View>
    </View>
  );
};

export default Header;
